module.exports = __webpack_public_path__ + "files/c9c58916a644630cde7530f6e5138e49.png";